import List from "@/components/list";
import router from "@/router";
// import vue from "@/main";

const Table = args => {

  // 报名审核
  function enrollAuditList(enroll) {
    router.push({
      path: "enrollaudit/users",
      query: {
        id: enroll.uuid,
        isAttachment: enroll.isAttachment,
        status: enroll.classStatus
      }
    });
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;

    return (
      <div class="deal-group">
        <el-tooltip
          content="报名审核"
          placement="top"
          v-permission="audit:enroll:list"
        >
          <i
            class="user-enroll-icon"
            onClick={() => enrollAuditList(enroll)}
          ></i>
        </el-tooltip>
      </div>
    );
  };

  const ClassStatusName = ({ props: { vo } }) => {
    const classStatusName = vo.row.classStatusName
      ? vo.row.classStatusName
      : "--";
    return <span>{classStatusName}</span>;
  };
  const EnrollTime = ({ props: { vo } }) => {
    let enrollTime = '';
    if (vo.row.enrollStartTime && vo.row.enrollEndTime) {
      enrollTime = vo.row.enrollStartTime + "～" + vo.row.enrollEndTime;
    } else {
      enrollTime = "--";
    }
    return <span>{enrollTime}</span>;
  };
  const AccountTableConfig = [
    {
      label: "班级名称",
      minWidth: "200",
      render: (vo) => (
        <div class="base-hover-char"
          onClick={() => {
            if (vo.row.isOnline == 1) {
              router.push({
                path: "/onlineClass/detail",
                query: { id: vo.row.uuid },
              });
            } else {
              router.push({
                path: "/offlineClass/detail",
                query: { id: vo.row.uuid },
              });
            }
          }}
        >
          {vo.row.className}
        </div>
      ),
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "承办单位",
      prop: "undertakeUnit",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "培训类型",
      width: "130",
      prop: "trainTypeName"
    },
    // {
    //   label: "办班级别",
    //   prop: "classLevelName",
    //   width: "100",
    //   showOverflowTooltip: true
    // },
    {
      label: "班级状态",
      prop: "classStatusName",
      width: "90",
      render: vo => <ClassStatusName vo={vo} />
    },
    {
      label: "报名情况",
      prop: "enrollSituation",
      minWidth: "110",
      showOverflowTooltip: true,
      renderHeader: () => {
        return (
          <div class="table-row-column">
            <span>报名情况</span>
            <span>报名|计划(人)</span>
          </div>
        )
      },
    },
    {
      label: "报名时间",
      prop: "enrollTime",
      width: "190",
      render: vo => <EnrollTime vo={vo} />
    },
    {
      label: "操作",
      fixed: "right",
      width: "80",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
